import * as i0 from '@angular/core';
import { InjectionToken, NgModule, Injectable, Inject, Component, inject } from '@angular/core';
import * as i1 from '@platform-idm/sdk-javascript';
import { Authentication } from '@platform-idm/sdk-javascript';
import { Subject } from 'rxjs';
const IDM_AUTHENTICATION_OPTIONS = new InjectionToken("IDM_AUTHENTICATION_OPTIONS");
//export declare const IDM_AUTHENTICATION_OPTIONS: InjectionToken<AuthenticationOptions>;
let PlatformIdmModule = /*#__PURE__*/(() => {
  class PlatformIdmModule {
    static initAuth(settings) {
      return {
        ngModule: PlatformIdmModule,
        providers: [{
          useValue: settings,
          provide: IDM_AUTHENTICATION_OPTIONS
        }]
      };
    }
  }
  PlatformIdmModule.ɵfac = function PlatformIdmModule_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || PlatformIdmModule)();
  };
  PlatformIdmModule.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
    type: PlatformIdmModule
  });
  PlatformIdmModule.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({});
  return PlatformIdmModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let PlatformIdmService = /*#__PURE__*/(() => {
  class PlatformIdmService {
    constructor(options) {
      this.options = options;
      this.$authentication = new Subject();
      this.authentication = new Authentication(options);
    }
    /**
    * Configure the library  wuth the following features
    * 1. Create local session based on the parsed_token query string
    * 2. Register the logout url in the shared cookie
    * 3. Configure the keep alive so there is a tokenre fresh request before it expires
    * 4. Configure idle,so you will get a warning event and automatic logout after x number of inactivity. x is t= retrieved from the access token
    */
    async configure() {
      await this.authentication.configure(t => {}, async seconds => {});
      if (this.authentication.isAuthenticated()) {
        this.$authentication.next(true);
      }
    }
  }
  PlatformIdmService.ɵfac = function PlatformIdmService_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || PlatformIdmService)(i0.ɵɵinject(IDM_AUTHENTICATION_OPTIONS));
  };
  PlatformIdmService.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
    token: PlatformIdmService,
    factory: PlatformIdmService.ɵfac,
    providedIn: 'root'
  });
  return PlatformIdmService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let PlatformIdmCreateSessionComponent = /*#__PURE__*/(() => {
  class PlatformIdmCreateSessionComponent {
    constructor(authIdmService) {
      this.authIdmService = authIdmService;
    }
    async ngOnInit() {
      var auth = this.authIdmService.authentication;
      await auth.extractClaimsFromQueryString();
      auth.redirectToCaller();
    }
  }
  PlatformIdmCreateSessionComponent.ɵfac = function PlatformIdmCreateSessionComponent_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || PlatformIdmCreateSessionComponent)(i0.ɵɵdirectiveInject(PlatformIdmService));
  };
  PlatformIdmCreateSessionComponent.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
    type: PlatformIdmCreateSessionComponent,
    selectors: [["ng-component"]],
    standalone: false,
    decls: 2,
    vars: 0,
    template: function PlatformIdmCreateSessionComponent_Template(rf, ctx) {
      if (rf & 1) {
        i0.ɵɵelementStart(0, "p");
        i0.ɵɵtext(1, "Creating Session ...");
        i0.ɵɵelementEnd();
      }
    },
    encapsulation: 2
  });
  return PlatformIdmCreateSessionComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

//export declare const IDM_AUTHENTICATION_OPTIONS: InjectionToken<AuthenticationOptions>;
let PlatformIdmTestingModule = /*#__PURE__*/(() => {
  class PlatformIdmTestingModule {
    static initAuth() {
      let settings = {
        app: 'test-app',
        backendServices: ['/'],
        environmentName: 'dev',
        ssoUrl: 'https://sso-dev.matrixcare.me',
        sso_serviceUrl: 'https://sso-service-dev.matrixcare.me',
        logoutUrl: '/logout',
        loginUrl: '/login',
        afterLoginRedirectTo: ''
      };
      return {
        ngModule: PlatformIdmModule,
        providers: [{
          useValue: settings,
          provide: IDM_AUTHENTICATION_OPTIONS
        }]
      };
    }
  }
  PlatformIdmTestingModule.ɵfac = function PlatformIdmTestingModule_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || PlatformIdmTestingModule)();
  };
  PlatformIdmTestingModule.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
    type: PlatformIdmTestingModule
  });
  PlatformIdmTestingModule.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({});
  return PlatformIdmTestingModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
const PlatformIdmCanActivate = (route, state) => {
  let authService = inject(PlatformIdmService);
  let authenticated = authService.authentication.isAuthenticated();
  if (!authenticated) {
    authService.authentication.redirectToLoginWithCurrentUrl();
    return false;
  }
  return authenticated;
};

/*
 * Public API Surface of ngx-platform-idm-sdk
 */

/**
 * Generated bundle index. Do not edit.
 */

export { IDM_AUTHENTICATION_OPTIONS, PlatformIdmCanActivate, PlatformIdmCreateSessionComponent, PlatformIdmModule, PlatformIdmService, PlatformIdmTestingModule };
